"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ImageLoader = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTransitionGroup = require("react-transition-group");
var _placeholder = _interopRequireDefault(require("../../placeholder"));
var _icon = _interopRequireDefault(require("../../icon"));
var _imageModule = _interopRequireDefault(require("./image.module.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ImageLoader = exports.ImageLoader = /*#__PURE__*/function (_Component) {
  function ImageLoader() {
    var _this;
    _classCallCheck(this, ImageLoader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ImageLoader, [].concat(args));
    _defineProperty(_this, "image", new Image());
    _defineProperty(_this, "state", {
      loaded: false,
      fallback: false
    });
    _defineProperty(_this, "setLoaded", function () {
      _this.setState({
        loaded: true
      });
    });
    _defineProperty(_this, "setFallback", function () {
      _this.setState({
        loaded: true,
        fallback: true
      });
    });
    _defineProperty(_this, "getStyles", function (state) {
      var transitionStyles = {
        entering: {
          opacity: 1,
          display: "block"
        },
        entered: {
          opacity: 1,
          display: "block"
        },
        exiting: {
          opacity: 0
        },
        exited: {
          opacity: 0,
          display: "none"
        }
      };
      return _objectSpread({}, transitionStyles[state]);
    });
    _defineProperty(_this, "renderLoading", function () {
      var placeholderRef = /*#__PURE__*/_react["default"].createRef();
      return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.Transition, {
        "in": !_this.state.loaded,
        timeout: 300,
        nodeRef: placeholderRef
      }, function (state) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          ref: placeholderRef,
          className: _imageModule["default"].image,
          style: _this.getStyles(state)
        }, /*#__PURE__*/_react["default"].createElement(_placeholder["default"], {
          animate: true,
          width: _this.props.width,
          height: _this.props.height
        }));
      });
    });
    _defineProperty(_this, "shouldRenderImage", function () {
      return _this.state.loaded && !_this.state.fallback;
    });
    _defineProperty(_this, "shouldRenderFallback", function () {
      return _this.state.loaded && _this.state.fallback;
    });
    _defineProperty(_this, "renderImage", function () {
      var loaderRef = /*#__PURE__*/_react["default"].createRef();
      return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.Transition, {
        "in": _this.shouldRenderImage(),
        timeout: 300,
        nodeRef: loaderRef
      }, function (state) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          ref: loaderRef,
          className: _imageModule["default"].image,
          style: _this.getStyles(state)
        }, /*#__PURE__*/_react["default"].createElement("img", {
          src: _this.props.src,
          alt: _this.props.alt,
          style: {
            width: _this.props.width,
            height: _this.props.height
          }
        }));
      });
    });
    _defineProperty(_this, "renderFallback", function () {
      var fallbackRef = /*#__PURE__*/_react["default"].createRef();
      return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.Transition, {
        "in": _this.shouldRenderFallback(),
        timeout: 300,
        nodeRef: fallbackRef
      }, function (state) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          ref: fallbackRef,
          className: _imageModule["default"].image,
          style: _this.getStyles(state)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _imageModule["default"].fallback,
          style: {
            width: _this.props.width,
            height: _this.props.height,
            borderRadius: _this.props.fallbackIconBorderRadius
          }
        }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
          type: _this.props.fallbackIconType,
          style: {
            fontSize: _this.props.fallbackIconFontSize
          }
        })));
      });
    });
    return _this;
  }
  _inherits(ImageLoader, _Component);
  return _createClass(ImageLoader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setImage();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.src !== prevProps.src) {
        this.setState({
          loaded: false,
          fallback: false
        });
        this.setImage();
      }
    }
  }, {
    key: "setImage",
    value: function setImage() {
      this.image.src = this.props.src;
      this.image.onload = this.setLoaded;
      this.image.onerror = this.setFallback;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": "image-loader",
        className: _imageModule["default"].imageContainer,
        style: {
          width: this.props.width,
          height: this.props.height
        }
      }, this.renderImage(), this.renderFallback(), this.renderLoading());
    }
  }]);
}(_react.Component);
ImageLoader.propTypes = {
  width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired,
  height: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired,
  alt: _propTypes["default"].string.isRequired,
  url: _propTypes["default"].string.isRequired,
  fallbackIconType: _propTypes["default"].string,
  fallbackIconFontSize: _propTypes["default"].number,
  fallbackIconBorderRadius: _propTypes["default"].string
};
ImageLoader.defaultProps = {
  width: 100,
  height: 100,
  alt: "",
  url: "",
  fallbackIconType: "TShirt",
  fallbackIconFontSize: 30,
  fallbackIconBorderRadius: "5px"
};
var _default = exports["default"] = ImageLoader;